export default "__VITE_ASSET__CtkdCkyF__"